// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_container__yWowe {
  border-radius: 0.5em;
  padding: 1em;
  margin: auto;
  align-content: center;
}

.container_displayFlex__Q3zT5 {
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
}

.container_displayGrid__zP3AR {
  display: grid;
  align-items: center;
  box-sizing: border-box;
}

.container_contentContainer__28XP0 {
  position: relative;
}

.container_contentLoader__parvG {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
}

.container_containerFade__VSy-\\+ {
  position: relative;
  margin: 0.5em;
}

.container_foreground__UnfMe {
  position: absolute;
  border-radius: 15px;
  inset: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
}

.container_message__-C9rk {
  font-size: 46px;
  color: #dfe6e9;
  margin: auto;
}

.container_icon__GCkIr {
  animation: container_asd__xYWcv 4s ease infinite;
}

@keyframes container_asd__xYWcv {
  0% {
    transform: rotate(-30deg);
  }
  50% {
    transform: rotate(30deg);
  }
  100% {
    transform: rotate(-30deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Container/container.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gDAA+B;AACjC;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".container {\n  border-radius: 0.5em;\n  padding: 1em;\n  margin: auto;\n  align-content: center;\n}\n\n.displayFlex {\n  display: flex;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n}\n\n.displayGrid {\n  display: grid;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.contentContainer {\n  position: relative;\n}\n\n.contentLoader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.containerFade {\n  position: relative;\n  margin: 0.5em;\n}\n\n.foreground {\n  position: absolute;\n  border-radius: 15px;\n  inset: 0;\n  display: flex;\n  background: rgba(0, 0, 0, 0.7);\n}\n\n.message {\n  font-size: 46px;\n  color: #dfe6e9;\n  margin: auto;\n}\n\n.icon {\n  animation: asd 4s ease infinite;\n}\n\n@keyframes asd {\n  0% {\n    transform: rotate(-30deg);\n  }\n  50% {\n    transform: rotate(30deg);\n  }\n  100% {\n    transform: rotate(-30deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_container__yWowe`,
	"displayFlex": `container_displayFlex__Q3zT5`,
	"displayGrid": `container_displayGrid__zP3AR`,
	"contentContainer": `container_contentContainer__28XP0`,
	"contentLoader": `container_contentLoader__parvG`,
	"containerFade": `container_containerFade__VSy-+`,
	"foreground": `container_foreground__UnfMe`,
	"message": `container_message__-C9rk`,
	"icon": `container_icon__GCkIr`,
	"asd": `container_asd__xYWcv`
};
export default ___CSS_LOADER_EXPORT___;
